import useSolrUrlSync from "./use-solr-url-sync";

/**
 * Render-nothing component that syncs Solr filter state to the URL.
 * Place inside SolrProvider to enable URL persistence for that overview.
 */
const URLSync = () => {
  useSolrUrlSync();
  return null;
};

export default URLSync;
